/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Invite_PlaceholderInputs */

const es_admin_users_invite_placeholder = /** @type {(inputs: Admin_Users_Invite_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email@empresa.com`)
};

const en_admin_users_invite_placeholder = /** @type {(inputs: Admin_Users_Invite_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email@company.com`)
};

/**
* | output |
* | --- |
* | "email@company.com" |
*
* @param {Admin_Users_Invite_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_invite_placeholder = /** @type {((inputs?: Admin_Users_Invite_PlaceholderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Invite_PlaceholderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_invite_placeholder(inputs)
	return en_admin_users_invite_placeholder(inputs)
});
export { admin_users_invite_placeholder as "admin.users.invite.placeholder" }